export default {
  head: {
    title: 'Voice sessions billing',
    action: {
      create: {
        tooltip: 'Create new Voice report'
      },
      search: {
        tooltip: 'Search single session by Session Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Voice billing session'
    },
    details: {
      title: 'Voice session details'
    }
  }
};
